import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    setTimeout(() => {
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 200);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=ethereal%20fashion%20model%20wearing%20flowing%20lustrous%20silver%20white%20satin%20evening%20gown%20standing%20by%20still%20moonlit%20water%20at%20night%2C%20dramatic%20moonlight%20illumination%20from%20above%2C%20dark%20cinematic%20background%20with%20silver%20and%20blue%20tones%2C%20luxury%20fashion%20brand%20campaign%20photography%2C%20high%20fashion%20editorial%2C%20atmospheric%20mysterious%20elegance&width=1920&height=1080&seq=iif_hero_001&orientation=landscape"
        alt="i-if hero — wear the moonlight"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-midnight/50 via-midnight/30 to-midnight/60" />

      {/* Content */}
      <div
        ref={textRef}
        className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6"
        style={{
          opacity: 0,
          transform: "translateY(24px)",
          transition: "opacity 1s ease, transform 1s ease",
        }}
      >
        {/* Eyebrow */}
        <p
          className="text-[10px] tracking-ultra-wide uppercase text-moonlight/70 mb-6"
          style={{ fontFamily: "'Jost', sans-serif", letterSpacing: "0.3em" }}
        >
          New Season — The Luminous Edit
        </p>

        {/* Main Title */}
        <h1
          className="text-5xl md:text-7xl lg:text-8xl font-light italic text-moonlight leading-none mb-6"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Wear the
          <br />
          <em className="not-italic font-normal" style={{ color: "#E8E6E3" }}>
            Moonlight.
          </em>
        </h1>

        {/* Subtitle */}
        <p
          className="text-sm md:text-base text-moonlight/70 max-w-md mb-10 leading-relaxed"
          style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300, letterSpacing: "0.05em" }}
        >
          Lustrous satin, metallic shimmer, iridescent glow.
          <br />
          Fashion that illuminates.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/collections/clothes"
            className="px-10 py-3.5 bg-moonlight text-midnight text-xs tracking-widest uppercase hover:bg-moon-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Jost', sans-serif" }}
          >
            Shop the Collection
          </Link>
          <Link
            to="/pages/the-glow-edit"
            className="px-10 py-3.5 border border-moonlight/50 text-moonlight text-xs tracking-widest uppercase hover:border-moonlight hover:bg-moonlight/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Jost', sans-serif" }}
          >
            The Glow Edit
          </Link>
        </div>

        {/* Scroll Hint */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <p
            className="text-[9px] tracking-widest uppercase text-moonlight/40"
            style={{ fontFamily: "'Jost', sans-serif" }}
          >
            Scroll
          </p>
          <div className="w-px h-10 bg-gradient-to-b from-moonlight/40 to-transparent" />
        </div>
      </div>
    </section>
  );
}
